import { z } from "zod";

export const searchBarAnimationConfigSchema = z.object({
  enabled: z.boolean().default(true),
  duration: z.number().positive().default(3.5),
  scale: z.tuple([z.number(), z.number(), z.number()]).default([1, 1.4, 1]),
  opacity: z.tuple([z.number(), z.number(), z.number()]).default([0.5, 1, 0.5]),
  ease: z.enum(["linear", "easeIn", "easeOut", "easeInOut"]).default("easeInOut"),
});

export const searchBarPayloadSchema = z.object({
  animation: searchBarAnimationConfigSchema.default({
    enabled: true,
    duration: 3.5,
    scale: [1, 1.4, 1],
    opacity: [0.5, 1, 0.5],
    ease: "easeInOut",
  }),
  gradientColors: z.array(z.string()).min(1).default([
    "rgba(124, 58, 237, 1)",
    "rgba(139, 92, 246, 0.95)",
    "rgba(167, 139, 250, 0.9)",
    "rgba(192, 132, 252, 0.85)",
    "rgba(217, 119, 255, 0.75)",
    "rgba(240, 171, 252, 0.6)",
    "rgba(251, 207, 232, 0.4)",
  ]),
});

export type SearchBarAnimationConfig = z.infer<typeof searchBarAnimationConfigSchema>;
export type SearchBarPayload = z.infer<typeof searchBarPayloadSchema>;
